// Header
document.addEventListener('DOMContentLoaded', function () {
    const toggleButton = document.querySelector('#mobile-menu-button');
    const headerSection = document.querySelector('#shopify-section-header');
    const mobileMenu = document.getElementById('mobile-menu');

    if (!toggleButton || !headerSection || !mobileMenu) return;

    toggleButton.addEventListener('click', function () {
        headerSection.classList.toggle('is-active');

        // Swap hidden and md:hidden
        if (mobileMenu.classList.contains('hidden')) {
            mobileMenu.classList.remove('hidden');
            //   mobileMenu.classList.add('md:hidden');
        } else {
            mobileMenu.classList.add('hidden');
            //   mobileMenu.classList.remove('md:hidden');
        }
    });
});

window.addEventListener('scroll', () => {
    if (window.scrollY > 50) {
        document.querySelector('.kiks-header .header-container').classList.add('kiks-sticky');
        // document.querySelector('.kiks-header .header-container').classList.remove('!absolute');
    } else {
        document.querySelector('.kiks-header .header-container').classList.remove('kiks-sticky');
        // document.querySelector('.kiks-header .header-container').classList.add('!absolute');
    }
});


// factory-gallery section
document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.show-more').forEach(function (button) {
        const section = button.closest('.factory-gallery');
        if (!section) return;

        const images = section.querySelectorAll('.image-items img');

        if (images.length <= 3) return;

        // ✅ Show first 3, hide the rest
        images.forEach((img, index) => {
            img.style.display = index > 2 ? 'none' : 'block';
        });

        let expanded = false;

        button.addEventListener('click', function () {
            expanded = !expanded;

            images.forEach((img, index) => {
                if (index > 2) {
                    img.style.display = expanded ? 'block' : 'none';
                }
            });

            const span = button.querySelector('span');
            if (span) {
                span.textContent = expanded ? 'Show Less' : 'Show More';
            }
        });
    });
});
